import axios from "axios";
import { Kitchen } from "../types/auth";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
});

const kitchensApi = {
  getAccessibleKitchens: async (): Promise<{ kitchens: Kitchen[] }> => {
    const response = await axios.get(
      `${API_URL}/api/admin/kitchens/accessible`,
      getAuthHeaders()
    );
    return response.data;
  },

  getAdminKitchens: async (): Promise<{ kitchens: Kitchen[] }> => {
    const response = await axios.get(
      `${API_URL}/api/admin/kitchens`,
      getAuthHeaders()
    );
    return response.data;
  },

  createKitchen: async (payload: Partial<Kitchen>) => {
    const response = await axios.post(
      `${API_URL}/api/admin/kitchens`,
      payload,
      getAuthHeaders()
    );
    return response.data;
  },

  updateKitchen: async (kitchenId: string, payload: Partial<Kitchen>) => {
    const response = await axios.put(
      `${API_URL}/api/admin/kitchens/${kitchenId}`,
      payload,
      getAuthHeaders()
    );
    return response.data;
  },

  toggleRainMode: async (kitchenId: string, isRainMode: boolean) => {
    const response = await axios.post(
      `${API_URL}/api/kitchens/rain-mode`,
      { kitchenId, isRainMode },
      getAuthHeaders()
    );
    return response.data;
  },

  deleteKitchen: async (kitchenId: string) => {
    const response = await axios.delete(
      `${API_URL}/api/admin/kitchens/${kitchenId}`,
      getAuthHeaders()
    );
    return response.data;
  },
};

export default kitchensApi;
